import { gunterzBold } from '@/theme/fonts';
import type { SocialLinkItemType } from '@/types';
import { useLingui } from '@lingui/react';
import { Box, Image, Modal, Stack, Text, rem } from '@mantine/core';
import { useCallback } from 'react';
import type { SocialDialogType } from '.';
import classes from './SocialAuthDialog.module.css';
export type SocialSuccessDialogProps = Pick<SocialLinkItemType, 'title'> & {
  stack: SocialDialogType;
  setActive: (active: boolean) => void;
};
export const SocialSuccessDialog: React.FC<SocialSuccessDialogProps> = ({
  stack,
  title,
  setActive
}) => {
  const {
    i18n
  } = useLingui();
  const handleCloseDialog = useCallback(() => {
    setActive(true);
    stack.closeAll();
  }, [stack, setActive]);
  return <Modal.Root {...stack.register('success')} centered classNames={classes} onClose={handleCloseDialog}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header px={20} pt={32} pb={0}>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body px={20} pb={32}>
          <Stack align="center" gap={32}>
            <Image src="/assets/icon_success.svg" w={96} h={96} alt="icon-success" />
            <Box>
              <Text c="var(--text-prime)" ta="center" fz={25} lh={rem(25)} className={gunterzBold.className}>
                {i18n._('Success!')}
              </Text>
              <Text fz="xs" mt={16} ta="center" c="var(--text-dark)" fw={700} tt="uppercase">
                {i18n._('Your {title} account is now linked.', {
                title
              })}
              </Text>
            </Box>
          </Stack>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>;
};